/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from "react";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import {
  savePositionDrillAction,
  getPositionDrillAction,
  getPositionsAction,
  getDrillsAction,
} from "../../../../store/CombineActions";
import PositionDrillList from "./list";
import { setDrills } from "../../../../store/slices/combineSlice";
import { toast } from "react-toastify";

export default function PositionDrills({ eventId, athleteId }) {
  const apiInstance = useAxiosInstance();
  const dispatch = useDispatch();
  const r_combine = useSelector((state) => state.combine);
  const angleRef = useRef(null);
  const videoRef = useRef(null);
  const positionRef = useRef(null);
  const drillRef = useRef(null);
  const repRef = useRef(null);

  const [loadingDrills, setLoadingDrills] = useState(false);
  const [loadingVideo, setLoadingVideo] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [selectedPosition, setSelectedPosition] = useState(null);
  const [selectedDrill, setSelectedDrill] = useState(null);
  const [selectedRep, setSelectedRep] = useState("1");
  const [showPositionList, setShowPositionList] = useState(false);
  const [showDrillList, setShowDrillList] = useState(false);
  const [showRepList, setShowRepList] = useState(false);

  const repOptions = Array.from({ length: 10 }, (_, i) => `${i + 1}`);

  useEffect(() => {
    dispatch(getPositionsAction(apiInstance));
    dispatch(setDrills([]));
  }, [athleteId]);

  useEffect(() => {
    if (!r_combine.reload) {
      dispatch(getPositionDrillAction(apiInstance, athleteId, eventId));
    }
  }, [eventId, athleteId, dispatch, r_combine.reload]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        positionRef.current &&
        !positionRef.current.contains(event.target) &&
        drillRef.current &&
        !drillRef.current.contains(event.target) &&
        repRef.current &&
        !repRef.current.contains(event.target)
      ) {
        setShowPositionList(false);
        setShowDrillList(false);
        setShowRepList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChangePosition = (id) => {
    setSelectedPosition(id);
    setSelectedDrill(null);
    setLoadingDrills(true);
    dispatch(getDrillsAction(apiInstance, id, setLoadingDrills));
    setShowPositionList(false);
  };

  const handleChangeDrill = (id) => {
    setSelectedDrill(id);
    setShowDrillList(false);
  };

  const handleChangeRep = (rep) => {
    setSelectedRep(rep);
    setShowRepList(false);
  };

  const resetForm = () => {
    videoRef.current.value = null;
    angleRef.current.value = null;
  };

  const handleChangeVideo = async () => {
    const file = videoRef.current?.files?.[0];

    if (!file || !selectedDrill || !selectedPosition) {
      toast.warning("Please complete all selections.", {
        position: "top-right",
      });
      return;
    }

    if (!file.type.startsWith("video/")) {
      toast.warning("Only video files are allowed!", { position: "top-right" });
      return;
    }

    const maxSizeInBytes = 600 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      toast.warning("Video size should not exceed 600MB.", {
        position: "top-right",
      });
      return;
    }

    const formData = new FormData();
    formData.append("userId", athleteId);
    formData.append("eventId", eventId);
    formData.append("drillId", selectedDrill);
    formData.append("rep", selectedRep);
    formData.append("angle", angleRef.current.value);
    formData.append("file", file);

    const data = {
      positionId: selectedPosition,
      drillId: selectedDrill,
    };
    setLoadingVideo(true);
    await dispatch(
      savePositionDrillAction(
        apiInstance,
        formData,
        toast,
        setLoadingVideo,
        data,
        resetForm,
        setUploadProgress,
      ),
    );
  };

  const dropdownArrow = (
    <svg
      className="w-5 h-5 ml-2 inline-block text-gray-700"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );

  return (
    <>
      {loadingVideo && (
        <div className="h-full w-full bg-white/5 top-0 left-0 fixed z-10"></div>
      )}
      {r_combine.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="p-2 border-b border-gray-300 pb-4 mb-2 relative">
          <div className="pb-4 text-lg font-medium">Add Position Drills</div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Position Dropdown */}
            <div className="relative" ref={positionRef}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Positions
              </label>
              <div
                className="w-full border border-gray-300 rounded-md p-2 cursor-pointer bg-white flex justify-between items-center"
                onClick={() => setShowPositionList(!showPositionList)}
              >
                <span>
                  {r_combine.positions.find((p) => p.id == selectedPosition)
                    ?.name || "-- Select Positions --"}
                </span>
                {dropdownArrow}
              </div>
              {showPositionList && (
                <ul className="absolute z-10 mt-1 bg-white border border-gray-300 w-full rounded shadow max-h-44 overflow-auto">
                  {r_combine.positions.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => handleChangePosition(item.id)}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Drill Dropdown */}
            {loadingDrills ? (
              <LoadingSpinner />
            ) : (
              <div className="relative" ref={drillRef}>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Select Drills
                </label>
                <div
                  className={`w-full border rounded-md p-2 cursor-pointer flex justify-between items-center ${
                    selectedPosition
                      ? "bg-white border-gray-300"
                      : "bg-gray-100 border-gray-200 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (selectedPosition) setShowDrillList(!showDrillList);
                  }}
                >
                  <span>
                    {selectedPosition
                      ? r_combine.drills.find((d) => d.id == selectedDrill)
                          ?.name || "-- Select --"
                      : "-- Select  Drills --"}
                  </span>
                  {dropdownArrow}
                </div>
                {showDrillList && selectedPosition && (
                  <ul className="absolute z-10 mt-1 bg-white border border-gray-300 w-full rounded shadow max-h-44 overflow-auto">
                    {r_combine.drills.map((item) => (
                      <li
                        key={item.id}
                        onClick={() => handleChangeDrill(item.id)}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      >
                        {item.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {/* Rep Dropdown */}
            <div className="relative" ref={repRef}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Rep
              </label>
              <div
                className="w-full border border-gray-300 rounded-md p-2 cursor-pointer bg-white flex justify-between items-center"
                onClick={() => setShowRepList(!showRepList)}
              >
                <span>{`Rep ${selectedRep}`}</span>
                {dropdownArrow}
              </div>
              {showRepList && (
                <ul className="absolute z-10 mt-1 bg-white border border-gray-300 w-full rounded shadow max-h-44 overflow-auto">
                  {repOptions.map((rep) => (
                    <li
                      key={rep}
                      onClick={() => handleChangeRep(rep)}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    >
                      Rep {rep}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* Angle and File Upload */}
          {r_combine.drills.length > 0 && (
            <div className="flex space-x-4">
              <div className="flex space-x-4 pt-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Angle Name
                  </label>
                  <input
                    ref={angleRef}
                    type="text"
                    placeholder="Enter Angle Name"
                    className="w-full border border-gray-300 rounded-md p-2"
                    maxLength={36}
                  />
                </div>

                <div className="flex items-end">
                  <label className="w-full border-2 border-dashed border-blue-400 rounded-md p-2 text-center text-gray-500 cursor-pointer hover:bg-blue-50">
                    <input
                      ref={videoRef}
                      type="file"
                      className="hidden"
                      onChange={handleChangeVideo}
                      accept="video/*"
                    />
                    <div className="flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 mb-1 text-blue-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-4l-4-4m0 0l-4 4m4-4v12"
                        />
                      </svg>
                      <span className="text-sm pl-4">
                        Click To Upload Video
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          )}

          {loadingVideo && (
            <div className="w-full pr-2 mb-2">
              <div className="bg-gray-300 rounded-full h-2 w-full">
                <div
                  className="bg-green-600 h-2 rounded-full transition-all duration-300 ease-in-out"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-600 mt-1 text-right pr-1">
                Uploading: {uploadProgress}%
              </p>
            </div>
          )}
        </div>
      )}
      <PositionDrillList />
    </>
  );
}
